import React, { memo } from 'react'

import { oneOf } from 'prop-types'

import { LIBRARY_TAB } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import EmptyStateIllustration from 'Pods/ThreeDStudio/Shared/EmptyStateIllustration/EmptyStateIllustration'

// Live region so a search that flips the grid from results to nothing is announced
// instead of silently swapping the cards out.
function NotFoundState({ tab = LIBRARY_TAB.MODELS }) {
  const t = useTranslation()

  return (
    <div className="not-found-state" role="status" aria-live="polite">
      <EmptyStateIllustration glyph={tab === LIBRARY_TAB.IMAGES ? 'image' : 'cube'} size="small" />
      <p className="not-found-state__text cgt-body-base-semibold">
        {t('sidebar.library.notFound.text')}
      </p>
    </div>
  )
}

NotFoundState.propTypes = {
  tab: oneOf([LIBRARY_TAB.MODELS, LIBRARY_TAB.IMAGES]),
}

export default memo(NotFoundState)
